import KTCheckbox, {
  KTCheckboxType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTCheckbox';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

DragItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.object,
  index: PropTypes.number.isRequired,
  moveItem: PropTypes.func,
  checked: PropTypes.bool,
  onCheckChanged: PropTypes.func,
  onDragDone: PropTypes.func,
};

function DragItem({
  id,
  label = {},
  index,
  moveItem,
  checked = false,
  onCheckChanged,
  onDragDone,
}) {
  // ---- params ----
  const ref = useRef();
  const [{ handlerId }, drop] = useDrop({
    accept: 'CARD',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveItem(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'CARD',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    // end: (item, monitor) => {
    //   if (onDragDone) {
    //     onDragDone(item);
    //   }
    // },
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div
      ref={ref}
      key={id}
      className="border d-flex"
      style={{
        // border: '1px dashed gray',
        backgroundColor: 'white',
        cursor: 'grab',
        opacity: opacity,
      }}
    >
      <div
        className="p-3 d-flex align-items-center"
        style={{
          borderRight: `1px solid ${AppColors.gray[300]}`,
          backgroundColor: AppColors.gray[100],
        }}
      >
        <KTTooltip text="Di chuyển">
          <i className="fa-solid fa-bars" style={{ fontSize: 12 }} />
        </KTTooltip>
      </div>
      <KTCheckbox
        additionalClassName="checkbox-success p-3"
        name={`checkbox_${id}`}
        label={
          <div
            className="ml-2"
            style={{
              fontWeight: 400,
              fontSize: 14,
              color: AppColors.gray[800],
            }}
          >
            {label?.props?.children}
          </div>
        }
        type={KTCheckboxType.default}
        checked={checked}
        onChange={(checked) => {
          if (onCheckChanged) onCheckChanged(id, checked);
        }}
      />
    </div>
  );
}

export default DragItem;
